import commonConstant from '../../common/_commonConstant';
import { getCookieToken, getCookieUserId, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history, profileErrorDetail } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetProfile = () => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/${getCookieUserId()}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PROFILE_SUCCESS,
          'data': (
            data.data ?
              {
                ...data.data,
                'user': {
                  ...data.data.user,
                  'userProfile': data.data.user.userProfile ? JSON.parse(data.data.user.userProfile) : null,
                },
              }
              : null
          ),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PROFILE_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PROFILE_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchUpdateProfilePassword = (currentUserPassword, newUserPassword) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/${getCookieUserId()}/reset-password`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PATCH',
        'body': JSON.stringify({ currentUserPassword, newUserPassword }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_PROFILE_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401 || res.status === 403) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.UPDATE_PROFILE_FAILURE,
          'data': data.detail ? { 'reason': profileErrorDetail(data.detail) } : null,
          'status': res.status,
          'detail': data.detail ? data.detail : null,
          'dateTime': new Date(),
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_PROFILE_FAILURE,
        'data': null,
        'status': res.status ? res.status : null,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_PROFILE_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
